import { cmsCall } from "@/lib/cms";
import { displayVatRate } from "@/lib/product";

const PENDING_KEY = "shop_pending_payment";

export function makeReference() {
  const d = new Date();
  const stamp = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
  return `WS-${stamp}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
}

/** Bedragen: subtotaal excl. BTW -> korting -> BTW per orderregel -> totaal incl. BTW. */
export function calcAmounts(lines, kortingPercentage, account) {
  const round = (n) => Math.round(n * 100) / 100;
  const pct = Number(kortingPercentage) || 0;
  let subtotaal = 0;
  let btw = 0;
  lines.forEach((l) => {
    const regel = Number(l.product?.verkoopprijs || 0) * Number(l.aantal || 0);
    const naKorting = regel * (1 - pct / 100);
    subtotaal += regel;
    btw += naKorting * (displayVatRate(l.product, account) / 100);
  });
  subtotaal = round(subtotaal);
  const kortingBedrag = round(subtotaal * (pct / 100));
  const exclNaKorting = round(subtotaal - kortingBedrag);
  btw = round(btw);
  return {
    subtotaal,
    korting_percentage: pct,
    korting_bedrag: kortingBedrag,
    totaal_excl_btw: exclNaKorting,
    btw_bedrag: btw,
    totaal_incl_btw: round(exclNaKorting + btw),
  };
}

export function savePending(data) {
  try {
    window.localStorage.setItem(PENDING_KEY, JSON.stringify(data));
  } catch (e) {
    /* ignore */
  }
}

export function readPending(reference) {
  try {
    const raw = window.localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (reference && data.reference !== reference) return null;
    return data;
  } catch (e) {
    return null;
  }
}

export function clearPending(reference) {
  const data = readPending();
  if (!reference || !data || data.reference === reference) {
    try {
      window.localStorage.removeItem(PENDING_KEY);
    } catch (e) {
      /* ignore */
    }
  }
}

/**
 * Plaatst de CRM-order met de JWT van de klant (frontend), inclusief het
 * afgesproken "betaling"-object, en meldt daarna het CRM-ordernummer terug
 * aan de eigen backend zodat het betaalrecord compleet is.
 */
export async function placePaidOrder({ bestellen, pending, betaling, t }) {
  const a = pending.amounts;
  const betaaldOp = betaling.betaald_op || new Date().toISOString();
  const samenvatting = `${t("payment.paidLine")} — ${a.korting_percentage}% korting, totaal incl. BTW EUR ${a.totaal_incl_btw.toFixed(2)} (ref ${pending.reference})`;
  const referentie = (pending.referentie || "").trim();
  const opmerking = [referentie ? `${t("checkout.referentieInOpmerking", { referentie })}` : "", pending.opmerking, samenvatting].filter(Boolean).join(" | ");

  const result = await bestellen(
    pending.lines.map((l) => ({ product_id: l.product_id, aantal: Number(l.aantal) })),
    opmerking,
    {
      methode: "mollie",
      status: "betaald",
      mollie_payment_id: betaling.mollie_payment_id,
      korting_percentage: a.korting_percentage,
      korting_bedrag: a.korting_bedrag,
      totaal_excl_btw: a.totaal_excl_btw,
      btw_bedrag: a.btw_bedrag,
      totaal_incl_btw: a.totaal_incl_btw,
      betaald_op: betaaldOp,
    },
    referentie ? { klant_referentie: referentie } : {},
  );

  try {
    await cmsCall("POST", `/betalingen/${pending.reference}/order`, {
      crm_order_id: result.ordernummer || result.verkoopkans_id || "",
    });
  } catch (e) {
    /* betaalrecord bijwerken mag de order niet blokkeren */
  }
  return result;
}
